<template>
    <div class="Contact">
        <div class="News-wrap">
            <h3>专业游艇码头 制造商<br>Professional Floating Dock Manufacturer</h3>
        </div>

        <div class="navigation-wrap">

            <div class="navigation-bar">
                <div class="navigation-left-bar">
                    <p>您的位置：</p>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/News' }">联系方式</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </div>

        <div class="contact_wrap">
            <h1>联系方式</h1>
            <div class="contact_box">
                <h3>{{ $brand.companyCn }}</h3>
                <div class="contact_text">
                    <p>地址：广东省广州市南沙区海滨路185号822房</p>
                    <!-- <p>客服热线：0750-2331903</p> -->
                    <p>网址（WEB)：{{ $brand.web }}</p>
                    <p>电话：189 2532 8565，189 2532 8685 </p>
                    <p>邮箱：{{ $brand.emails }}</p>
                    <p>微信：yannickhe</p>


                </div>
            </div>

            <div class="contact_box">
                <h3>{{ $brand.companyEn }}</h3>
                <div class="contact_text">
                    <p>Add：R822, No185, Haibin Road, Nansha District, Guangzhou, China</p>
                    <!-- <p>客服热线：0750-2331903</p> -->
                    <p>WEB：{{ $brand.web }}</p>
                    <p>Tel：+86 189 2532 8565，  +86 189 2532 8685 </p>
                    <p>Email：{{ $brand.emails }}</p>
                    <p>Wechat：yannickhe</p>


                </div>
            </div>


        </div>
        <div class="Case_wrap">
            <section class="destination" id="destination">

                <div class="heading">
                    <span>精美案例</span>
                    <h1>为您带来更多的可能性</h1>
                </div>

                <div class="box-container">


                    <div class="box" data-aos="fade-up" data-aos-delay="450">
                        <router-link to="/Case">
                        <div class="image">
                            <img src="../assets/images/des-3.jpg" alt="">
                        </div>
                        <div class="content">
                            <h3>国外项目</h3>
                            <p>2020-06<br>卡塔尔铝合金码头<br>案例</p>
                            <a href="#">了解更多 <i class="fas fa-angle-right"></i></a>
                        </div>
                        </router-link>
                    </div>

                    <div class="box" data-aos="fade-up" data-aos-delay="600">
                        <router-link to="/Case">
                        <div class="image">
                            <img src="../assets/images/des-4.jpg" alt="">
                        </div>
                        <div class="content">
                            <h3>国外项目</h3>
                            <p>2018-10 <br>迪拜码头<br>案例</p>
                            <a href="#">了解更多<i class="fas fa-angle-right"></i></a>
                        </div>
                        </router-link>
                    </div>

                    <div class="box" data-aos="fade-up" data-aos-delay="750">
                        <router-link to="/Case">
                        <div class="image">
                            <img src="../assets/images/des-5.jpg" alt="">
                        </div>
                        <div class="content">
                            <h3>国内案例</h3>
                            <p>2021-05<br>福建漳州沙滩网红冲浪浮桥<br>案例</p>
                            <a href="#">了解更多 <i class="fas fa-angle-right"></i></a>
                        </div>
                        </router-link>
                    </div>



                </div>

            </section>
        </div>

        <!-- banner section star-ts  -->

        <!-- <div class="banner">

            <div class="content" data-aos="zoom-in-up" data-aos-delay="300">
                <span>富升实业</span>
                <h3>专业浮动码头制造商</h3>
                <p>富升实业有限公司是一家专业从事于游艇码头，浮动码头，浮桥，浮动防波提，光伏浮筒及配套设施的企业，也是一家集研发、设计、销售、生产、施工、维护为一体化的专业公司。本公司拥有一支从业经验超过10年的专业团队，积累了丰富的水上工程经验和技术。
                </p>
                <a href="#book-form" class="btn">联系我们</a>
            </div>

        </div> -->

        <!-- banner section ends -->
    </div>
</template>

<script>
    export default {
        name: 'pm-distribution',
        components: {

        }
        // 原百度地图已废弃：key 被禁用会导致页面弹 alert，且地图早已不展示。
        // 以后要用地图，用天地图 / 高德，或新申请 key 后重新实现。
    }
</script>

<style>
    .Contact section{
        padding: 3rem 9%;
    }

    .contact_wrap {
        max-width: 1200px;
        margin: 0 auto;
    }

    .contact_wrap h1 {
        position: relative;
        font-size: 34px;
        font-weight: normal;
        margin: 10px auto;
        width: 400px;
        color: #000;
    }

    .contact_wrap h1::after {
        content: "";
        position: absolute;
        width: 100px;
        height: 1px;
        background: rgb(163, 163, 163);
        top: 50%;
        left: 0;
    }

    .contact_wrap h1::before {
        content: "";
        position: absolute;
        width: 100px;
        height: 1px;
        background: rgb(163, 163, 163);
        top: 50%;
        right: 0;
    }

    .contact_box {
        text-align: left;
    }

    .contact_box h3 {
        font-size: 24px;
        margin: 30px 0;
        font-style: italic;
        color: #000;
    }

    .contact_box .contact_text p {
        font-size: 14px;
        margin-top: 10px;
        color: #222;
    }

    @media screen and (max-width:768px) {
        .contact_wrap h1 {
            width: 100%;
        }

        .contact_wrap {
            margin: 15px;
        }

        .contact_wrap h2 {
            width: 100%;
        }
    }
</style>